import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import CustomerPendingIssues from "../../features/manageCustomers/customerPendingIssues";
import CustomerOngoingIssues from "../../features/manageCustomers/customerOngoingIssues";
import CustomerCompletedIssues from "../../features/manageCustomers/customerCompletedIssues";
import { useLazyGetIssueQuery } from "../../services/main";
import { ROLES } from "../../utils/enums";
import { Category, Issue } from "../../types/General";
import { isValidInput } from "../../utils/validations";
import TableComponent from "../../components/TableComponent";
import StarIcon from "@mui/icons-material/Star";
import { GridColDef } from "@mui/x-data-grid";
import RatingModal from "../../Modals/rating";
import moment from "moment";
import { useLazyGetCategoryQuery } from "../../services/category";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerIssues = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [getIssues] = useLazyGetIssueQuery();
  const [getCategory] = useLazyGetCategoryQuery();

  const [valueTabs, setValueTabs] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState<number>(1);
  const [rows, setRows] = useState<Issue[]>([]);
  const [category, setCategory] = useState<Category[]>([]);
  const [count, setCount] = useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectField, setSelectField] = useState("");
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const getAllCategory = async () => {
    try {
      const response = await getCategory({
        page: 1,
        limit: 10,
        search: "",
      }).unwrap();
      if (response?.statusCode === 200) {
        setCategory(response?.data?.list || []);
      }
    } catch (error) {}
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "property",
      headerName: "Property Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.propertyId?.name || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "name",
      headerName: "Issue Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure className="no_radius">
              <img
                src={
                  row?.image?.length
                    ? row?.image[0]
                    : "/static/images/placeholder.png"
                }
                alt=""
              />
            </figure>
            {/* <div className="imageDiv">
              {row?.image?.length
                ? row?.image?.map((item) => (
                    <figure>
                      <img
                        alt="user"
                        src={item || "/static/images/placeholder.png"}
                      />
                    </figure>
                  ))
                : null}
            </div> */}
            <p>{row?.name || ""}</p>
          </div>
        );
      },
    },
    {
      flex: 2,
      minWidth: 250,
      field: "description",
      headerName: "Issue Description",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 120,
      field: "category",
      headerName: "Category",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.categoryId?.categoryName || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "dateTime",
      headerName: "Date & Time",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "offers",
      headerName: "Offers",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() => navigate(`/manage-issues/offers/${row?._id}`)}
          >
            View
          </Button>
        );
      },
    },
  ];

  const columnsCompleted: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "property",
      headerName: "Property",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 200,
      field: "name",
      headerName: "Issue Name",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <figure className="no_radius">
              <img src="/static/images/placeholder.png" alt="" />
            </figure>
            <p>Sink Leakage</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 220,
      field: "maintenance",
      headerName: "Offered By",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate("/manage-maintenance-team/detail")}
          >
            <figure className="no_radius">
              <img src="/static/images/placeholder.png" alt="" />
            </figure>
            <p>
              <b>Maintenance Team 1</b> <span>maintenance@gmail.com</span>
            </p>
          </div>
        );
      },
    },
    {
      minWidth: 150,
      field: "offered",
      headerName: "Offered Price",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return (
          <p className="c_primary">
            <strong>AED 200</strong>
          </p>
        );
      },
    },
    {
      minWidth: 150,
      field: "tax",
      headerName: "Taxes & Charges",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return (
          <p>
            <strong>AED 40</strong>
          </p>
        );
      },
    },
    {
      minWidth: 150,
      field: "commission",
      headerName: "Commission",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return (
          <p>
            <strong>AED 20</strong>
          </p>
        );
      },
    },
    {
      minWidth: 150,
      field: "total",
      headerName: "Grand Total",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return (
          <p className="c_success">
            <strong>AED 260</strong>
          </p>
        );
      },
    },
    {
      minWidth: 240,
      field: "preferred",
      headerName: "Payment Method",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <p>
            <strong>American Express My Zone Card</strong> <br />{" "}
            <span>xxxx xxxx xxxx 5678</span>
          </p>
        );
      },
    },
    {
      minWidth: 120,
      field: "rating",
      headerName: "Rating",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return (
          <span className="star_rating" onClick={() => setOpen(true)}>
            <StarIcon /> 4.0
          </span>
        );
      },
    },
    {
      minWidth: 180,
      field: "dateTime",
      headerName: "Date & Time",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 130,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: () => {
        return <span className="btn_text c_success">Paid</span>;
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "offers",
      headerName: "Offers",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() => navigate("/manage-issues/offers")}
          >
            View
          </Button>
        );
      },
    },
  ];

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const handleChange = (event: SelectChangeEvent) => {
    setSelectField(event.target.value as string);
  };

  const getAllIssues = async (propertyId: string) => {
    setIsLoading(true);
    try {
      const response = await getIssues({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        id: propertyId ? propertyId : "",
        status: valueTabs + 1,
        type: selectField || "",
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.data || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  useEffect(() => {
    if (id) {
      getAllIssues(id);
    }
  }, [debouncedSearchTerm, page, valueTabs, selectField]);

  return (
    <>
      <MainContainer>
        {/* <div className="main_title">
          <h1>Manage Issues</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Issues
          </p>
        </div> */}

        <div className="main_title">
          <h1>Customer Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-customers")}>
              Manage Customers
            </span>{" "}
            - Customer Issues
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Pending Issues" {...a11yProps(0)} />
                <Tab label="Ongoing Issues" {...a11yProps(1)} />
                <Tab label="Completed Issues" {...a11yProps(2)} />
              </Tabs>
            </Box>
          </div>
        </div>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder="Searchsss..."
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s form">
              <Select
                fullWidth
                value={selectField}
                displayEmpty
                onChange={handleChange}
              >
                <MenuItem value="">Select Property</MenuItem>
                {category?.length
                  ? category?.map((item) => (
                      <MenuItem value={item?._id} key={item?._id}>
                        {item?.categoryName || ""}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </div>
          </div>
          <CustomTabPanel value={valueTabs} index={0}>
            <div className="sorting_table">
              <TableComponent
                columns={columns}
                rows={rows}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                loading={isLoading}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="sorting_table">
              <TableComponent
                columns={columns}
                rows={rows}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                loading={isLoading}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <div className="sorting_table">
              <TableComponent
                columns={columnsCompleted}
                rows={rows}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                loading={isLoading}
              />
            </div>
          </CustomTabPanel>
        </div>
        <RatingModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
      </MainContainer>
    </>
  );
};

export default ManageCustomerIssues;
